import { validColor } from "@/lib/color";
import type { OrgGroup } from "@/lib/types";
import OrgName from "./OrgName";

// 2단: 집행부 — 받은 순서대로 2열 지그재그 배치.
// 그리드가 행 단위로 채워지므로 좌열=0,2,4 / 우열=1,3,5 로 자동 지그재그가 된다.
// members 가 2명 이상인 그룹(감사)은 한 상자 안에 세로로 쌓는다.
export default function OrgExecGrid({ groups }: { groups: OrgGroup[] }) {
  if (groups.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
      {groups.map((g, i) => (
        <div
          key={g.no ?? i}
          className="org-card overflow-hidden rounded-xl border border-background-200"
        >
          <div
            className="px-3 py-2.5 text-center text-sm font-bold text-white"
            style={{ backgroundColor: validColor(g.color) ?? "oklch(var(--primary-700))" }}
          >
            {g.name}
          </div>
          <div className="space-y-2 bg-background-50 px-4 py-4 text-center">
            {g.members?.map((m, mi) => (
              <div key={m.no ?? mi} className="text-sm font-semibold text-foreground-800">
                <OrgName member={m} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}